import { useLearntCount, usePracticeCount, useDaysPracticeCount, useRecordDayPracticeCount, usePracticeTodayCount, useStreak } from "../../hooks/useALSE"
import { ErrorView } from "../Misc/ErrorView";
import { Loading } from "../Misc/Loading";
import { month_names } from "../../config";
import Calendar from "../Calendar/Calendar";
import './Achievements.css'
import CookiesModal from "../CookiesModal/CookiesModal";

const level_emojis = ["",
    "🍼", "🎈", "🚲", "📚", "🛼", // 1-5 (beginner, playful, learning stages)
    "🛹", "🎮", "🏹", "🪓", "🔦", // 6-10 (basic tools, minor challenges)
    "🛡️", "⚔️", "🎯", "🏆", "🏎️", // 11-15 (gear, competition, exploration)
    "🌟", "🗝️", "📜", "🔮", "🐉", // 16-20 (magic, mystery, fantasy)
    "🏰", "🧪", "🧲", "🛡️", "⚒️", // 21-25 (advanced gear, crafting, protection)
    "🪙", "💎", "🔗", "🌌", "🧭", // 26-30 (treasures, cosmic exploration)
    "🌠", "🎩", "🗡️", "🔱", "🪄", // 31-35 (heroes, magic, power-ups)
    "🏹", "🛡️", "🧞", "👑", "🛸", // 36-40 (legendary, rulers, sci-fi)
    "⚡", "🌋", "🚀", "🌪️", "🔥", // 41-45 (natural forces, intense powers)
    "🧨", "💫", "🌍", "🦸", "🧙", // 46-50 (universal mastery, magical artifacts)
]

function PracticesCount(practices_count: number | null, error: string | null, loading: boolean) {
    if (error)
        return <ErrorView error={Error(error)} />
    if (loading || practices_count === null)
        return <Loading />
    
    const level = Math.floor(Math.sqrt(practices_count));
    const level_log10 = level > 0 ? Math.floor(Math.log10(level)) : 0;
    const emoji_level = Math.min(Math.floor(level / 10), level_emojis.length - 1);
    const level_points = level**2;
    const next_level_points = (level + 1)**2;
    const level_percentage = Math.round(((practices_count - level_points) / (next_level_points - level_points) * 10000) || 0) / 100; // 2 decimal places percentage
    
    const sliderStyle: React.CSSProperties = {
        width: `${level_percentage}%`
    };

    return <div className={"level-container level-" + Math.min(level_log10, 2)}>
        <div className="level">Nivel: {level}</div>
        <div className="slider-container">
            <div className="slider-progress" style={sliderStyle}></div>
        </div>
        <div className="level-emoji">{level_emojis[emoji_level]}</div>
    </div>
}

export default function Achievements() {
    const { data: practices_count, error: practices_count_error, loading: practices_count_loading} = usePracticeCount([]);
    const { data: learnt_count, error: learnt_count_error, loading: learnt_count_loading} = useLearntCount([]);
    const { data: days_practice_count, error: days_practice_count_error, loading: days_practice_count_loading} = useDaysPracticeCount([]);
    const { data: practices_today_count, error: practices_today_count_error, loading: practices_today_count_loading} = usePracticeTodayCount([]);
    const { data: record_day_practice_count, error: record_day_practice_count_error, loading: record_day_practice_count_loading} = useRecordDayPracticeCount([]);
    const { data: streak, error: streak_error, loading: streak_loading } = useStreak([]);
    

    const recordDate = new Date(record_day_practice_count?.date.toString() ?? '');
    return <div className="component-container container-md">
        { PracticesCount(practices_count, practices_count_error, practices_count_loading) }
        <Calendar />
        { !learnt_count_error              && !learnt_count_loading              && <div className="mb-2">⭐ Has marcado <b>{learnt_count} signo{learnt_count !== 1 ? 's' : ''}</b> como <b>favorito{learnt_count !== 1 ? 's' : ''}</b>!</div> }
        { !practices_count_error           && !practices_count_loading           && <div className="mb-2">✏️ Has <b>practicado {practices_count} signo{practices_count !== 1 ? 's' : ''}</b>!</div> }
        { !days_practice_count_error       && !days_practice_count_loading       && <div className="mb-2">📆 Has practicado signos <b>{days_practice_count} día{days_practice_count !== 1 ? 's distintos' : ''}</b>!</div> }
        { !practices_today_count_error     && !practices_today_count_loading     && <div className="mb-2">🕑 <b>Hoy</b> has practicado <b>{practices_today_count} signo{practices_today_count !== 1 ? 's' : ''}</b>!</div> }
        { !streak_error                    && !streak_loading                    && streak?.streak !== 1 && <div className="mb-2">🏅 Llevas una <b>racha</b> de <b>{streak?.streak ?? 0} días</b> seguidos practicando!</div> }
        { !record_day_practice_count_error && !record_day_practice_count_loading && recordDate && <div className="mb-2">🏆 El día <b>{recordDate.getDate()} de {month_names[recordDate.getMonth()]} del {recordDate.getFullYear()}</b> batiste tu <b>record</b>, practicando <b>{record_day_practice_count?.count} signo{record_day_practice_count?.count !== 1 ? 's' : ''}</b>!</div> }
        <CookiesModal/>
    </div>
}